"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array-buffer.detached.js");
require("core-js/modules/es.array-buffer.transfer.js");
require("core-js/modules/es.array-buffer.transfer-to-fixed-length.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.typed-array.at.js");
require("core-js/modules/es.typed-array.find-last.js");
require("core-js/modules/es.typed-array.find-last-index.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.to-reversed.js");
require("core-js/modules/es.typed-array.to-sorted.js");
require("core-js/modules/es.typed-array.with.js");
require("core-js/modules/esnext.uint8-array.set-from-base64.js");
require("core-js/modules/esnext.uint8-array.set-from-hex.js");
require("core-js/modules/esnext.uint8-array.to-base64.js");
require("core-js/modules/esnext.uint8-array.to-hex.js");
require("core-js/modules/web.dom-exception.stack.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _clientsContacts = require("@/api/clients-contacts");
var _jszip = _interopRequireDefault(require("jszip"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _jimp = _interopRequireDefault(require("jimp"));
var _jpegJs = _interopRequireDefault(require("jpeg-js"));
var _index = _interopRequireDefault(require("@/components/Enabled/index.vue"));
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      file: ''
    };
    this.acceptableFormats = ['application/zip'];
    this.fieldsMap = {
      name: 'name',
      first_name: 'firstName',
      last_name: 'lastName',
      contact_number: 'mobileNumber',
      client_email_address: 'emailAddress',
      Category: 'categorization',
      'Brand name ': 'brand'
    };
    this.file = null;
    this.fileTemp = null;
    this.fileExcelToJsonProgressing = false;
    this.fileRead = false;
    this.clientContactNameIndexMap = {};
    this.clientContactData = [];
    this.processingClientContact = false;
    this.currentlyProcessingIndex = -1;
    this.processingLength = 10;
    this.processedClientContacts = 0;
    this.failedClientContacts = 0;
    this.pauseProcessingClientContact = false;
    this.importExcelBinary = null;
    // private importExcel: any = [];
    this.uploading = false;
    this.statusColorMap = {
      Pending: 'success',
      Approved: 'primary',
      Rejected: 'danger'
    };
    this.uploadStatusesMap = {
      '': 'info',
      pending: 'info',
      uploading: 'warning',
      uploaded: 'primary',
      failed: 'danger'
    };
  }
  reset() {
    this.postForm.file = '';
    this.fileExcelToJsonProgressing = false;
    this.fileRead = false;
    this.clientContactData = [];
    this.clientContactNameIndexMap = {};
    this.processingClientContact = false;
    this.currentlyProcessingIndex = -1;
    this.processedClientContacts = 0;
    this.failedClientContacts = 0;
    this.pauseProcessingClientContact = false;
  }
  async created() {
    _jimp.default.decoders['image/jpeg'] = data => _jpegJs.default.decode(data, {
      maxMemoryUsageInMB: 1024 * 2
    });
  }
  async handleChange(file) {
    this.reset();
    this.fileExcelToJsonProgressing = true;
    try {
      const isZIP = ['application/zip', 'application/x-zip-compressed'].indexOf(file.raw.type) > -1;
      if (!isZIP) {
        return this.$message.error('File must be in ZIP format! \nWe found:' + file.raw.type);
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        return this.$message.error('File size can not exceed 100MB!');
      }
      await this.extractZip(file);
      await this.processExcel();
      this.fileRead = true;
    } catch (error) {
      this.$notify.error(error + '');
    } finally {
      this.fileExcelToJsonProgressing = false;
    }
  }
  async extractZip(file) {
    const This = this;
    const zip = new _jszip.default();
    return new _jszip.default.external.Promise(function (resolve, reject) {
      _jszip.default.loadAsync(file.raw).then(function (zip) {
        // loop over
        for (const fileName in zip.files) {
          const file = zip.files[fileName];
          // read Excel
          if (fileName === 'import.xlsx') {
            This.importExcelBinary = file;
          } else if (!file.dir) {
            // check if file is image
            const fileName = file.name;
          }
        }
        // return promise
        resolve(true);
      });
    });
    // });
  }
  async processExcel() {
    const This = this;
    const zip = new _jszip.default();
    if (!this.importExcelBinary) {
      throw new Error('Excel is empty');
    }
    return new _jszip.default.external.Promise(function (resolve, reject) {
      This.importExcelBinary.async('nodebuffer').then(fileData => {
        var workbook = _xlsx.default.read(fileData, {
          type: 'array'
        });
        var firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        var outData = _xlsx.default.utils.sheet_to_json(firstSheet, {
          defval: null
        });
        This.clearData(outData);
        resolve(true);
      });
    });
  }
  // Processing method when exceeding the maximum number of uploaded files
  handleExceed() {
    this.$message({
      type: 'warning',
      message: 'Exceed the maximum number of uploaded files limit!'
    });
  }
  // How to remove files
  handleRemove(file, fileList) {
    this.fileTemp = null;
  }
  importfxx(obj) {
    this.fileRead = false;
    this.fileExcelToJsonProgressing = true;
    const _this = this;
    const inputDOM = this.$refs.inputer;
    // Retrieving file data through DOM
    this.file = this.fileTemp;
    var rABS = false; // Read the file as a binary string
    var f = this.file;
    var reader = new FileReader();
    // if (!FileReader.prototype.readAsBinaryString) {
    FileReader.prototype.readAsBinaryString = function (f) {
      var binary = '';
      var rABS = false; // Read the file as a binary string
      var pt = this;
      var wb; // Read completed data
      let outdata = [];
      var reader = new FileReader();
      reader.onload = function (e) {
        var result = reader.result;
        var bytes = new Uint8Array(result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        // If not introduced in main.js, you need to introduce it here to parse excel
        // var XLSX = require("xlsx");
        if (rABS) {
          wb = _xlsx.default.read(btoa(_this.fixdata(binary)), {
            // Manual conversion
            type: 'base64'
          });
        } else {
          wb = _xlsx.default.read(binary, {
            type: 'binary'
          });
        }
        _this.fileRead = true;
        _this.fileExcelToJsonProgressing = false;
        outdata = _xlsx.default.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
          defval: null
        });
        _this.clearData(outdata);
      };
      reader.readAsArrayBuffer(f);
    };
    if (rABS) {
      reader.readAsArrayBuffer(f);
    } else {
      reader.readAsBinaryString(f);
    }
  }
  fixdata(data) {
    let o = '';
    let l = 0;
    const w = 10240;
    for (; l < data.byteLength / w; ++l) {
      const sliced = new Uint8Array(data.slice(l * w, l * w + w));
      o += String.fromCharCode.apply(null, sliced);
    }
    const sliced = new Uint8Array(data.slice(l * w));
    o += String.fromCharCode.apply(null, sliced);
    return o;
  }
  clearData(excelProductData = []) {
    // loop
    for (let index = 1; index < excelProductData.length; index++) {
      const clientContact = this.getClientContactToBeProcessed(excelProductData[index]);
      clientContact.uploadedToServer = false;
      clientContact.uploadStatus = 'pending';
      // push
      const pushedIndex = this.clientContactData.push(clientContact) - 1;
      this.clientContactNameIndexMap[clientContact.firstName + clientContact.lastName] = pushedIndex;
    }
  }
  async processClientContact() {
    if (this.currentlyProcessingIndex < this.clientContactData.length - 1) {
      // increase index
      this.currentlyProcessingIndex++;
      const clientContactToBeProcessed = this.currentlyProcessingIndex in this.clientContactData ? {
        ...this.clientContactData[this.currentlyProcessingIndex]
      } : null;
      if (!clientContactToBeProcessed) {
        return;
      }
      try {
        var _response$errors, _response$successfulP;
        this.processedClientContacts++;
        this.pauseProcessingClientContact = false;
        this.processingClientContact = true;
        clientContactToBeProcessed.uploadStatus = 'uploading';
        const response = await (0, _clientsContacts.importClientsContact)([clientContactToBeProcessed]);
        // check if any of these failed
        if ((_response$errors = response.errors) !== null && _response$errors !== void 0 && _response$errors.length) {
          response.errors.forEach(failed => {
            if (failed.reason) {
              this.clientContactData[clientContactToBeProcessed.index].uploadStatus = 'failed';
              this.clientContactData[clientContactToBeProcessed.index].failedReason = failed.reason.message;
              this.failedClientContacts++;
            }
          });
        } else if ((_response$successfulP = response.successfulPromises) !== null && _response$successfulP !== void 0 && _response$successfulP.length) {
          this.clientContactData[clientContactToBeProcessed.index].uploadedToServer = true;
          // add id to product
          this.clientContactData[clientContactToBeProcessed.index].id = response.successfulPromises[0].value.id;
          // update status
          this.clientContactData[clientContactToBeProcessed.index].uploadStatus = 'uploaded';
        }
      } catch (error) {
        this.$message({
          type: 'warning',
          message: error.toString()
        });
        // update status
        this.clientContactData[clientContactToBeProcessed.index].uploadStatus = 'failed';
        this.clientContactData[clientContactToBeProcessed.index].failedReason = error.toString();
        this.failedClientContacts++;
        // check if it has been saved then delete from db
        if (this.clientContactData[clientContactToBeProcessed.index].id) {
          await (0, _clientsContacts.deleteClientsContact)(this.clientContactData[clientContactToBeProcessed.index].id);
        } // end if
      } finally {
        this.processingClientContact = false;
        if (this.currentlyProcessingIndex >= this.clientContactData.length) {
          this.currentlyProcessingIndex = -1;
        } else {
          // pause for a while
          setTimeout(async () => {
            if (!this.pauseProcessingClientContact) {
              await this.processClientContact();
            }
          });
        }
      }
    }
  }
  getClientContactToBeProcessed(clientContactToBeProcessed = {}) {
    if (clientContactToBeProcessed) {
      const clientContact = {};
      // convert to our desired format
      for (const key in clientContactToBeProcessed) {
        const value = clientContactToBeProcessed[key];
        // check if this key exist in Map
        if (key in this.fieldsMap) {
          clientContact[this.fieldsMap[key]] = value;
        }
      }
      return clientContact;
    }
    return false;
  }
  getUploadStatusType(uploadStatus = '') {
    return this.uploadStatusesMap[uploadStatus];
  }
  getTableRowClassName(row) {
    if (row.row.imageNotAvailable) {
      return 'error-row';
    }
    if (row.row.uploadStatus === 'failed') {
      return 'error-row';
    }
    if (row.row.uploadStatus === 'uploaded') {
      return 'success-row';
    }
    return '';
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientsContactImport',
  components: {
    Enabled: _index.default
  }
})], default_1);
var _default = exports.default = default_1;